<template>
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
        width="32.000000" height="32.000000" fill="none">
        <rect id="svg" width="32.000000" height="32.000000" x="0.000000" y="0.000000" />
        <rect id="4867" width="24.000000" height="24.000000" x="4.000000" y="4.000000" rx="2.666667"
            stroke="rgb(80,200,120)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.666667" />
        <path id="4868" d="M4 12L28 12" stroke="rgb(80,200,120)" stroke-linecap="round" stroke-linejoin="round"
            stroke-width="2.666667" />
        <path id="4869" d="M12 28L12 12" stroke="rgb(80,200,120)" stroke-linecap="round" stroke-linejoin="round"
            stroke-width="2.666667" />
    </svg>
</template>